export const FREE_TRIAL_COPY = {
  LOCKOUT: {
    TITLE: 'Trial complete!',
    MESSAGE: 'Ready to keep discovering?',
    DESCRIPTION:
      'Upgrade your plan to unlock full access and continue your research.',
    BUTTONS: {
      CONTACT: 'CONTACT NOW!',
      LOGOUT: 'Log out',
    },
  },
  TOASTS: {
    UPGRADE_REQUEST_SUCCESS:
      'Your upgrade request has been sent. A CSM will be in touch soon.',
    UPGRADE_REQUEST_ERROR:
      'Something went wrong. Please try again or contact your CSM.',
  },
} as const;

export type FreeTrialCopy = typeof FREE_TRIAL_COPY;
